export default __webpack_public_path__ + "static/media/neuromatch-academy-big-logo.f9418276.svg";